import ValidationModule from "./validationModule";
import ValidationException from "../../exceptions/validationException";

export default class ReservationFormModule {

    container = document.querySelector('.reservation-form');
    form = null;
    formButton = document.getElementById('reservationButton');
    formData = {
        name: null,
        surname: null,
        email: null,
        phoneNumber: null,
        countOfPerson: null,
        arrivalTime: null,
        withInvoice: null,
        taxNumber: null,
        nameOnInvoice: null,
        street: null,
        postCode: null,
        city: null,
        countryId: null
    };
    step = 1;

    settings = null;
    locale = null;
    notification = null;
    initialData = null;
    agreementsModule = null;
    calculator = null;
    isNonRefundable = false;
    isBundle = false;

    submitInitiated = false;

    constructor(initialData, calculator, agreementsModule, settings, locale, notification) {
        this.initialData = initialData;
        this.calculator = calculator;
        this.agreementsModule = agreementsModule;
        this.settings = settings;
        this.locale = locale;
        this.notification = notification;
        this.isBundle = this.initialData.bundleId !== null;
        this.prepareReservationFormModule();

        this.validation = new ValidationModule(
            this.formData,
            this.locale,
            this.settings
        );
    }

    prepareReservationFormModule = () => {
        const { formButton, formData } = this;
        const form = this.form = document.querySelector('.reservation-form form');

        if (form !== null) {
            this.prepareFormData();

            formButton.addEventListener('click', () => {
                this.setStep();
                this.scrollToTop();
            });
            let module = this;

            if (document.querySelector('input[name="offerType"]')) {
                document.querySelectorAll('input[name="offerType"]').forEach((elem) => {
                    elem.addEventListener("change", function (event) {
                        module.calculator.isNonRefundable = (document.querySelector('input[name=offerType]:checked').value == "nonRefundable");
                        module.isNonRefundable = module.calculator.isNonRefundable;
                        module.calculator.rerender();
                        module.calculator.calculateReservationCost();
                    });
                });
            }

            formData.withInvoice.addEventListener('click', () => {
                if (formData.withInvoice.checked) {
                    form.querySelector('.invoice-section').classList.add('active');
                } else {
                    form.querySelector('.invoice-section').classList.remove('active');
                }
            });
            if (this.isBundle) {
                formData.countOfPerson.disabled = true;
            }
            formData.countOfPerson.addEventListener('change', () => {
//                this.calculator.recalculateReservationCosts();
            });
        }
    }

    prepareFormData = () => {
        let { form, formData } = this;

        for (const inputName in formData) {
            formData[inputName] = form.querySelector(`[name="${inputName}"]`);
        }
    }

    setStep = async () => {
        const { initialData, container } = this;

        switch (this.step) {
            case 1:
                this.isNonRefundable = (document.querySelector('input[name=offerType]:checked').value == "nonRefundable");
                // TODO: refaktor try catchy
                try {
                    if (glStatisticalCookies == true) {
                        window.dataLayer = window.dataLayer || [];
                        dataLayer.push({
                            event: "add_to_cart",
                            ecommerce: {
                                items: [
                                    {
                                        item_id: initialData.apartmentId,
                                        item_name: initialData.apartmentName,
                                        item_category: "Apartament",
                                        item_category2: initialData.cityName,
                                        item_category3: initialData.facilityName,
                                        item_variant: initialData.numberOfPeople,
                                        price: (this.calculator.calculateReservationCost()) / initialData.nightsNumber,
                                        quantity: initialData.nightsNumber
                                    }
                                ]
                            }
                        });
                    }
                }
                catch (e) {
                    //            console.log(e);
                }
                this.manageDisplayContent();
                this.step += 1;
                break;
            case 2:
                await this.validateFormData();
                if (this.validation.isValidate) {
                    if (this.agreementsModule.checkbox.acceptRegulations.checked) {
                        if (!this.submitInitiated) {
                            this.submitInitiated = true;
                            document.getElementById('UserAgreementEmailAllow').value = this.agreementsModule.checkbox.allowEmail !== null ? this.agreementsModule.checkbox.allowEmail.checked : true;
                            document.getElementById('UserAgreementPhoneAllow').value = this.agreementsModule.checkbox.allowPhoneNumber !== null ? this.agreementsModule.checkbox.allowPhoneNumber.checked : true;
                            document.getElementById('WithInvoice').value = container.querySelector('input[name="withInvoice"]').checked;
                            document.getElementById('IsNonRefundable').value = this.isNonRefundable;

                            document.getElementById("reservationButton").disabled = true;
                            document.getElementById("reservation-form").submit();
                        }
                    } else {
                        this.agreementsModule.checkbox.acceptRegulations.classList.add('error');
                        this.notification.show(this.notification.types.error, this.locale.acceptRegulations);
                    }
                }

                if (document.body.clientWidth < 901) {
                    const apartmentDescription = document.querySelector('.apartment-description');
                    this.resetButtonHoverState();
                    apartmentDescription.appendChild(this.formButton);
                }
                
                break;
        }

        if (document.body.clientWidth < 901) {
            const offsetTop = container.offsetTop;
            scroll({
                top: offsetTop,
                behavior: "smooth"
            });
        }
    }

    manageDisplayContent = () => {
        const mainSection = document.querySelector('.main-section');
        const apartmentDescription = document.querySelector('.apartment-description');
        const apartmentSlider = apartmentDescription.querySelector('.apartment-description__slider');
        const apartmentHeading = apartmentDescription.querySelector('.apartment-description__heading');
        const apartmentList = apartmentDescription.querySelector('.apartment-description-list');
        const apartmentFooter = apartmentDescription.querySelector('.apartment-description__footer');
        const apartmentInformations = document.querySelector('.apartment-informations');
        const reservationFormContainer = document.querySelector('.reservation-form');
        const reservationAgreementsContainer = document.querySelector('.reservation-agreements');
        const reservationBackButtonContainer = document.querySelector('.reservation-back-button');
        const reservationDetailsContainer = document.querySelector('.reservation-details');
        const paymentDetailsContainer = document.querySelector('.payment-details');
        const apartmentReservation = document.querySelector('.apartment-reservation');
        const discountContainer = apartmentReservation.querySelector('.apartment-reservation__discount');
        const servicesContainer = apartmentReservation.querySelector('.apartment-reservation__services');
        const offertContainer = apartmentReservation.querySelector('.apartment-reservation__offert');
        const infoContainer = apartmentReservation.querySelector('.apartment-reservation__info');

        switch (this.step) {
            case 1:
                mainSection.classList.add('stage1');
                apartmentHeading.classList.remove('active');
                apartmentSlider.classList.remove('active');
                apartmentList.classList.remove('active');
                apartmentFooter.classList.remove('active');
                apartmentInformations.classList.remove('active');
                discountContainer.classList.remove('active');
                servicesContainer.classList.remove('active');
                offertContainer.classList.remove('active');
                infoContainer.classList.remove('active');

                reservationFormContainer.classList.add('active');
                reservationAgreementsContainer.classList.add('active');
                reservationBackButtonContainer.classList.add('active');

                this.formButton.innerText = this.locale.bookButton;

                if (document.body.clientWidth <= 900) {
                    this.resetButtonHoverState();
                    apartmentDescription.appendChild(this.formButton);
                }
                
                break;

            case 2:
                reservationFormContainer.classList.remove('active');
                reservationAgreementsContainer.classList.remove('active');
                reservationBackButtonContainer.classList.remove('active');
                this.formButton.remove();

                reservationDetailsContainer.classList.add('active');
                paymentDetailsContainer.classList.add('active');
                break;
        }
    }

    resetButtonHoverState = () => {
        const button = this.formButton.cloneNode(true);
        this.formButton.remove();

        button.addEventListener('click', () => {
            this.setStep();
            this.scrollToTop();
        });
        
        this.formButton = button;
    }

    validateFormData = () => {
        this.validation.isValidate = true;

        return new Promise(async (resolve, reject) => {
            try {
                this.validation.validateName();
                this.validation.validateSurame();
                await this.validation.validateEmail();
                this.validation.validatePhoneNumber();
                this.validation.validateCountOfPerson();
                this.validation.validateArrivalTime();

                if (this.formData.withInvoice.checked) {
                    this.validation.validateTaxNumber();
                    this.validation.validateNameOnInvoice();
                    this.validation.validateStreet();
                    this.validation.validatePostCode();
                    this.validation.validateCity();
                }
            } catch (error) {
                if (error instanceof ValidationException) {
                    this.validation.isValidate = false;
                    this.notification.show(this.notification.types.error, error.message);
                }
            } finally {
                resolve();
            }
        });
    }

    scrollToTop = () => {
        const section = document.querySelector('.main-section');
        section.scrollIntoView({behavior: "smooth", block: "start", inline: "nearest"});
    }
}